export default {"src":"/_next/static/media/image-mob.a718edcb.svg","height":1013,"width":390,"blurWidth":0,"blurHeight":0};